// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"clicks-by-offer-type_cardHeader_ZPhuG","cardDropdown":"clicks-by-offer-type_cardDropdown_39HZf","chartPieNoData":"clicks-by-offer-type_chartPieNoData_2sYoj"};